import script from "./InquiryList.vue?vue&type=script&setup=true&lang=js"
export * from "./InquiryList.vue?vue&type=script&setup=true&lang=js"

import "./InquiryList.vue?vue&type=style&index=0&id=cdffa1c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdffa1c0"]])

export default __exports__